import { render } from "./CategoryMenuComponent.vue?vue&type=template&id=1ecf6478"
import script from "./CategoryMenuComponent.vue?vue&type=script&lang=js"
export * from "./CategoryMenuComponent.vue?vue&type=script&lang=js"

import "./CategoryMenuComponent.vue?vue&type=style&index=0&id=1ecf6478&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__